import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

const Search = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);

  const keyword = query.get('q');
  const page = Number(query.get('page') || 1);
  const sort = query.get('sort') || 'latest';

  const [products, setProducts] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    if (!keyword) return;

    axios.get('/api/search/products', {
      params: { q: keyword, page, sort }
    }).then(res => {
      setProducts(res.data.products || []);
      setTotalPages(res.data.total_pages || 0);
      setTotalCount(res.data.total_count || 0);
    });
  }, [keyword, page, sort]);

  const changeSort = (value) => {
    navigate(`/search?q=${keyword}&sort=${value}&page=1`);
  };

  const goPage = (p) => {
    navigate(`/search?q=${keyword}&sort=${sort}&page=${p}`);
  };

  return (
    <div className="product-list-wrapper">

      {/* 결과 헤더 */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5>
          “{keyword}” 검색 결과 ({totalCount}개)
        </h5>

        <select
          value={sort}
          onChange={(e) => changeSort(e.target.value)}
          className="form-select form-select-sm"
          style={{ width: '160px' }}
        >
          <option value="latest">최신순</option>
          <option value="price_asc">가격 낮은순</option>
          <option value="price_desc">가격 높은순</option>
        </select>
      </div>

      {/* 상품 없음 */}
      {products.length === 0 && <p>검색 결과가 없습니다.</p>}

      {/* 상품 그리드 */}
      <div className="product-grid">
        {products.map(p => (
          <div className="product-item" key={p.id}>
            <div
              className="product-link"
              onClick={() => navigate(`/product/${p.id}`)}
              style={{ cursor: 'pointer' }}
            >
              <div className="card-custom">
                <div className="card-img-box">
                  <img
                    src={`/static/${p.image_path}`}
                    alt={p.name}
                  />
                </div>

                <div className="card-body">
                  <h5 className="card-title">{p.name}</h5>
                  {p.short_description && (
                    <p className="card-text">{p.short_description}</p>
                  )}
                  <div className="card-footer-price">
                    <strong>{p.price.toLocaleString()}원</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* 페이징 */}
      {totalPages > 1 && (
        <nav className="mt-4">
          <ul className="pagination justify-content-center">
            {[...Array(totalPages)].map((_, i) => {
              const p = i + 1;
              return (
                <li key={p} className={`page-item ${p === page ? 'active' : ''}`}>
                  <button className="page-link" onClick={() => goPage(p)}>
                    {p}
                  </button>
                </li>
              );
            })}
          </ul>
        </nav>
      )}

      {/* ✅ ProductList와 동일한 스타일 */}
      <style>{`
        .product-list-wrapper {
          max-width: 1200px;
          margin: 20px auto 0;
          padding: 0 15px;
        }

        .product-grid {
          display: flex;
          flex-wrap: wrap;
          margin: 0 -8px;
        }

        .product-item {
          width: 50%;
          padding: 8px;
          box-sizing: border-box;
        }

        .product-link {
          text-decoration: none !important;
          color: inherit !important;
          display: block;
        }

        .card-custom {
          background: #fff;
          display: flex;
          flex-direction: column;
          height: 100%;
          border: none;
          box-shadow: none;
          transition: opacity 0.2s ease-in-out;
        }

        .product-link:hover .card-custom {
          opacity: 0.8;
        }

        .card-img-box img {
          width: 100%;
          aspect-ratio: 1 / 1;
          object-fit: cover;
          display: block;
        }

        .card-body {
          padding: 1rem;
          display: flex;
          flex-direction: column;
          flex: 1;
        }

        .card-title {
          font-size: 0.85rem;
          font-weight: 500;
          margin-bottom: 0.5rem;
        }

        .card-text {
          font-size: 0.85rem;
          color: #6c757d;
          margin-bottom: 1rem;
          line-height: 1.4;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .card-footer-price {
          margin-top: auto;
          font-size: 0.95rem;
          color: #000;
        }

        @media (min-width: 768px) {
          .product-item {
            width: 33.333%;
          }
          .card-custom {
            box-shadow: 0 0.125rem 0.25rem rgba(0,0,0,0.075);
          }
          .card-title {
            font-size: 1.1rem;
          }
        }
      `}</style>

    </div>
  );
};

export default Search;
